'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactChartjs = require('react-chartjs');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _PlanScorecardDefaultAllocation = require('./PlanScorecardDefaultAllocation.css');

var _PlanScorecardDefaultAllocation2 = _interopRequireDefault(_PlanScorecardDefaultAllocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardDefaultAllocation = (_dec = (0, _reactCssModules2.default)(_PlanScorecardDefaultAllocation2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardDefaultAllocation, _Component);

  function PlanScorecardDefaultAllocation(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardDefaultAllocation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardDefaultAllocation.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardDefaultAllocation)).call(this, props));

    _this.state = {
      allocationStats: props.allocationStats,
      planData: props.planData
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardDefaultAllocation, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          allocationStats = _state.allocationStats,
          planData = _state.planData;

      //

      return _react2.default.createElement(
        'div',
        { styleName: 'chart-headline' },
        allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(_reactChartjs.Doughnut, {
          data: [{ value: allocationStats.default.perc,
            // label: 'Default',
            color: '#313131' }, { value: allocationStats.default.percOther,
            // label: 'Other',
            color: '#D5D5D5' }],
          options: _config2.default.chartOptions,
          width: '150',
          height: '150'
        }),
        _react2.default.createElement(
          'div',
          null,
          allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(
            'div',
            { styleName: 'chart-headline-text' },
            _react2.default.createElement(
              'h2',
              null,
              allocationStats.default.percStr,
              ' of plan assets are invested in the target date option.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Target date option:'
              ),
              ' ',
              planData.default_fund_name
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'chart-sublede' },
            'Most employer-offered retirement plans have what\'s called a ',
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.methodology + '#targetdates',
                title: 'Target date funds',
                xstrong: true
              },
              'target date option'
            ),
            ', broadly diversified investments that offer different "target dates" for investors in different age brackets. These target date funds mostly invest in index funds that are not sustainably invested. If a retirement plan has automatic enrollment, the target date series is usually the default investment option, also known as the ',
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.methodology + '#qdia',
                title: 'Qualified Default Investment Alternative',
                xstrong: true
              },
              'Qualified Default Investment Alternative'
            ),
            '. When you sign up for the plan, your savings are put in a default investment, and most plan participants never switch. Even if plans don\'t have automatic enrollment, a target date series frequently serves as the de facto default, capturing more assets than any other plan options. For the overall plan scorecard above, we use the ',
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.methodology + '#why2050',
                title: 'Why the 2050 fund?',
                xstrong: true
              },
              '2050 target date'
            ),
            ' as the representative of the fund series.'
          )
        )
      );
    }
  }]);
  return PlanScorecardDefaultAllocation;
}(_react.Component), _class2.propTypes = {
  allocationStats: _react.PropTypes.object.isRequired,
  planData: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardDefaultAllocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardDefaultAllocation/PlanScorecardDefaultAllocation.js
// module id = 1413
// module chunks = 0